// @ts-nocheck
import { SafeDictionary } from "@insite/client-framework/Common/Types";
// import { ProductModel, VariantTraitModel } from "@insite/client-framework/Types/ApiModels"; // Store Custom Code
import cloneDeep from "lodash/cloneDeep";

/* Store Custom Code - Start */
import { ProductModel, TraitValueModel, VariantTraitModel } from "@insite/client-framework/Types/ApiModels";
import capitalizeWords from "@store/Framework/Common/Utilities/capitalizeWords";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
/* Store Custom Code - End */

export default function useFilteredVariantTraits(
    variantTraits: VariantTraitModel[],
    variantChildren: ProductModel[],
    variantSelection: SafeDictionary<string>,
    returnDisabled?: boolean,
) {
    const filteredVariantTraits = cloneDeep(variantTraits.slice());
    const childTraitValueLists = variantChildren.map(o => o.childTraitValues!);

    /* Store Custom Code - Start */
    const existingValueIds: string[] = [];
    childTraitValueLists.forEach(x => x.forEach(y => existingValueIds.push(y.id)));
    /* Store Custom Code - End */

    filteredVariantTraits.forEach(variantTrait => {
        let matchingChildTraitValueLists = cloneDeep(childTraitValueLists);
        Object.keys(variantSelection).forEach(variantTraitId => {
            const selectedTraitValueId = variantSelection[variantTraitId];
            if (!selectedTraitValueId || variantTraitId === variantTrait.id) {
                return;
            }

            matchingChildTraitValueLists = matchingChildTraitValueLists.filter(o =>
                o.some(childTraitValue => childTraitValue.id === selectedTraitValueId),
            );
        });

        const filteredValuesIds: string[] = [];
        matchingChildTraitValueLists.forEach(childTraitList => {
            const currentValue = childTraitList.find(traitValue => traitValue.styleTraitId === variantTrait.id);
            if (!currentValue) {
                return;
            }
            if (!filteredValuesIds.some(filteredValueId => filteredValueId === currentValue.id)) {
                filteredValuesIds.push(currentValue.id);
            }
        });
        if (returnDisabled) {
            variantTrait.traitValues!.forEach(traitValue => {
                if (filteredValuesIds.indexOf(traitValue.id) < 0) {
                    /* Store Custom Code - Start */
                    if (existingValueIds.includes(traitValue.id)) {
                        traitValue.isUnavailable = true;
                    } else {
                        traitValue.isDisabled = true;
                    }
                    /* Store Custom Code - End */
                }
            });
            variantTrait.traitValues!.sort((a, b) => a.sortOrder - b.sortOrder);
        } else {
            variantTrait.traitValues = variantTrait
                .traitValues!.filter(traitValue => filteredValuesIds.indexOf(traitValue.id) > -1)
                .sort((a, b) => a.sortOrder - b.sortOrder);
        }

        /* Store Custom Code - Start */
        variantTrait.traitValues?.forEach(x => {
            x.valueDisplay = capitalizeWords(x.valueDisplay);

            variantChildren.some(product => {
                const isMatch = product.childTraitValues?.some(z => z.id === x.id);

                if (isMatch) {
                    if (getBooleanProperty(product.properties.isTrim)) {
                        x.isTrim = true;
                    } else {
                        x.isTile = true;
                    }
                }

                return x.isTrim && x.isTile;
            });
        });
        /* Store Custom Code - End */
    });

    /* Store Custom Code - Start */
    return filteredVariantTraits
        .reduce((traitsResult, trait) => {
            if (!trait.traitValues) {
                return traitsResult;
            }

            const traitValues = trait.traitValues.reduce((valuesResult, value) => {
                if (value.isDisabled) {
                    return valuesResult;
                }

                return [...valuesResult, value];
            }, [] as TraitValueModel[]);

            if (!traitValues.length) {
                return traitsResult;
            }

            return [...traitsResult, { ...trait, traitValues }] as VariantTraitModel[];
        }, [] as VariantTraitModel[])
        .sort((a, b) => a.sortOrder - b.sortOrder);
    /* Store Custom Code - End */
}
